import { MarketStats } from '../../logic/aggregate-stats'
import { SummaryTile } from './SummaryTile'
import { testIds } from '@/ui/utils/testIds'

interface SummaryTilesProps {
  marketStats: MarketStats
}

export function SummaryTiles({ marketStats }: SummaryTilesProps) {
  let index = 0
  return (
    <div className="grid gap-2 md:grid-cols-3 md:gap-5">
      <SummaryTile
        title="Total Market Size"
        USDValue={marketStats.totalMarketSizeUSD}
        data-testid={testIds.markets.summary.tile(index++)}
        fancy
      />
      <SummaryTile
        title="Total Value Locked"
        USDValue={marketStats.totalValueLockedUSD}
        data-testid={testIds.markets.summary.tile(index++)}
      />
      <SummaryTile
        title="Total Borrows"
        USDValue={marketStats.totalBorrowsUSD}
        data-testid={testIds.markets.summary.tile(index++)}
      />
    </div>
  )
}
